import { cn } from "@/shared/lib/utils"
import { Logo } from "@/shared/components/logo"

interface ImageFallbackProps {
  className?: string
}

// Branded placeholder for avatar/profile images that fail to load. Renders the
// "P.ai" wordmark on the neutral skeleton surface without an image fetch, so
// it stays visible even when the shared image optimizer is degraded.
export function ImageFallback({ className }: ImageFallbackProps) {
  return (
    <div
      role="img"
      aria-label="Image unavailable"
      className={cn(
        "flex items-center justify-center bg-muted/80 text-foreground/40",
        className
      )}
    >
      <Logo showText={false} />
    </div>
  )
}
